import React from 'react';
import { Zap, Beaker, Plane, Car, Anchor, Shield, Building, Zap as Fuel } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { industries } from '../mock';

const iconMap = {
  'Zap': Zap,
  'Beaker': Beaker,
  'Plane': Plane,
  'Car': Car,
  'Anchor': Anchor,
  'Shield': Shield,
  'Building': Building,
  'Fuel': Fuel
};

export const Industries = () => {
  return (
    <section id="industries" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Industries We Serve
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Our premium materials power diverse industries across India and globally. 
            From critical infrastructure to cutting-edge technology applications.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((industry, index) => {
            const IconComponent = iconMap[industry.icon];
            
            return (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-lg bg-white text-center">
                <CardHeader className="pb-3">
                  <div className="mx-auto w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center mb-3 group-hover:bg-[#022d47] transition-colors duration-300">
                    <IconComponent className="h-6 w-6 text-slate-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-lg text-slate-900 group-hover:text-[#022d47] transition-colors">
                    {industry.name}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm text-slate-600">
                    {industry.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Industry Stats */}
        <div className="mt-20 bg-slate-900 rounded-2xl p-12 text-white">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#022d47] mb-2">15+</div>
              <div className="text-slate-300">Industries Served</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#022d47] mb-2">500+</div>
              <div className="text-slate-300">Active Clients</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#022d47] mb-2">99%</div>
              <div className="text-slate-300">On-Time Delivery</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#022d47] mb-2">24/7</div>
              <div className="text-slate-300">Technical Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};